import React, { useEffect, useState } from "react";  
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";  
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import getBackendUrl from "../../../../environment/BackendService";  
import { useLocation } from "react-router-dom";  
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";  
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";   
import { downloadCSV, fetchDataCallOnInitialLoad } from "../../../../common_nextgen/utils/UtilFunctions";
  
const usePharmacyList = (
  onSelect,
  hideModal,
  initialSelectParams,
  intialSelectMode,
  initialLookupType,
  selectParamsData
) => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]); /* Pharmacy List Data */

  const [selectMode, setSelectedMode] = useState(intialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [screenNumber, setScreenNumber] = useState("RCPAL004");
  const initialParams = screenNumber === "RCPAL006" ? {
    listName: lookupType ? selectParamsData?.listName ?? "" : "",
    listDesc: lookupType ? selectParamsData?.listDesc ?? "" : "",
  } : {
    listName: lookupType ? selectParamsData?.listName ?? "" : "",
    listDesc: lookupType ? selectParamsData?.listDesc ?? "" : "",
  };
  const [paramsData, setParamsData] = useState(
    initialParams); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const { ADD_PHARMACY_LIST, VIEW_PHARMACIES } = ROUTE_PATHS;

  const screen_title = "Select Pharmacy List";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "PAL Pharmacy ID List Name",
      name: "listName",
      label: "List",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];
  if (screenNumber === "RCPAL006") {  
    formFields.push({  
      fieldLabel: "PAL Pharmacy ID Description",
      name: "listDesc",
      label: "Description",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 25,
    });  
  }  

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  const handleBack = () => {
    if (lookupType === "external" && selectMode) {
      window.parent.postMessage(
        {
          type: "hideModal",
        },
        "*"
      );
    } else {
      hideModal();
    }
  };

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: handleBack,
      button_key: "F12",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        const paramDataMap = new Map();
        selectParams.forEach((key) => {
        if (rowData.hasOwnProperty(key["target"])) {
            paramDataMap.set(key["source"], rowData[key["target"]]);
        }
        });

        const paramData = Object.fromEntries(paramDataMap);
        if (lookupType !== "external") {
          onSelect(paramData);
        } else {
          window.parent.postMessage(
            { type: "responseData", data: paramData },
            "*"
          );
        }
      },
    },
    {
      label: "Pharmacies",
      icon: <span className="material-icons">local_pharmacy</span>,
      command: () => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCPAD001I",
          parameters: {
            palPharmacyIdListName: rowData["listName"],
            palPharmacyIdListDesc: rowData["listDesc"],
          },
        };
        window.top?.postMessage(message, "*");
      },
    },
  ];

  if (screenNumber === "RCPAL006") {  
    menuOptions.push({  
      label: "Display",  
      icon: <span className="material-icons">visibility</span>,  
      command: () => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCPAL002I",
          parameters: {
            palPharmacyIdListName: rowData["listName"]
          },
        };
        window.top?.postMessage(message, "*");
      }, 
    });  
  }  

  /* Data table column info. */
  const columnDef = [
    {
      header: "List",
      field: "listName",
    },
    {
      header: "Description",
      field: "listDesc",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "palPharmacyIdListName";

  /* Handler that fetches the data */
  const fetchData = async () => {
    console.log("fetch data");
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rcpalp`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        console.log("response", response);
        console.log(pageResponse.totalRecords);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, selectedOption, lookupType]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData, screenNumber: screenNumber });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcpalp/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, data } = event.data;
      if (type === "initData") {
        const externalData = data?.data || {};
        setSelectedMode(data?.selectMode);
        setLookupType("external");
        setParamsData({
          ...paramsData,
          listName: externalData?.paramsData?.listName || "",
        });
        setSelectParams(externalData?.params);
        if (externalData?.screenNumber) {
          setScreenNumber(externalData?.screenNumber)
        }
      }
    };
    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    setSelectedOption,
    selectMode,
  };
};  
  
export default usePharmacyList;  